import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query-keys';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';
import type { GetBoardInput } from '@/types/generated';
import type { GetBoardUIOutput } from '@/types/action-outputs';

type BoardQueryParams = Pick<GetBoardInput, 'board_id' | 'user_id'> & {
  dates?: GetBoardInput['dates'];
};

export function useBoardQuery(params: BoardQueryParams) {
  const enabled = !!(params.board_id || params.user_id);

  return useQuery({
    queryKey: queryKeys.board.detail(params),
    queryFn: () =>
      executeQuery<GetBoardInput, GetBoardUIOutput>(Action.GET_BOARD, params),
    staleTime: 1000 * 30, // 30s
    enabled,
  });
}
